import React from 'react'
import Layout from '../components/map/MapLayout'

const Explore = ({ dispatch, loading, listings, hasErrors }) => {
  return <Layout />
}

export default Explore
